import React from 'react';

const UpdateQuotation = () => {
    return (
        <div>
            update quotation
        </div>
    );
};

export default UpdateQuotation;